import axios from '../custom-axios/axios'

class DocumentTags {

    login = (username, password) => {
        return axios.post('/login', {}, {
            params: {
                'username': username,
                'password': password
            }
        }).then(resp => {
            const token = resp.data?.token
            if (token) {
                localStorage.setItem("token", token)
            }
            return resp
        });
    }

    logout = () => {
        localStorage.removeItem("token")
    }

    isAuthenticated = () => {
        return localStorage.getItem("token") !== null
    }

    updateAnnotation = (recipeId, startIndex, length, tag) => {
        const promise = axios.get('/update-annotation', {
            params: {
                'recipeId': recipeId,
                'startIndex': startIndex,
                'length': length,
                'tag': tag,
                'token': localStorage.getItem("token")
            }
        });
        promise.catch(err => {
            console.log(err);
            alert("Please login before you do the mapping!")
        })
        return promise;
    }

    removeAnnotation = (recipeId, startIndex, length) => {
        const promise = axios.get('/invalid-annotation', {
            params: {
                'recipeId': recipeId,
                'startIndex': startIndex,
                'length': length || 1,
                'token': localStorage.getItem("token")
            }
        });
        promise.catch(err => {
            console.log(err);
            alert("Please login before you do the mapping!")
        })
        return promise;
    }

    loadRecipes = () => {
        return axios.get('/recipes');
    }

    loadFooDis = () => {
        return axios.get('/foo-dis');
    }

    loadCafeteria = () => {
        return axios.get('/cafeteria');
    }

    loadUncurated = () => {
        return axios.get('/uncurrated');
    }

    loadTags = (recipeId) => {
        return axios.get('/nerData', {
            params: {
                'recipeId': recipeId
            }
        });
    }


    predict = (text, model) => {
        return axios.get('/predict', {
            params: {
                "text": text,
                "model": model
            }
        });
    }

    loadResources() {
        return axios.get('/tuning_resources');
    }

    foodOntoMap() {
        return axios.get('/food-onto-map')
    }

    hansard() {
        return axios.get('/hansard-all')
    }

    foodon() {
        return axios.get('/foodon-all')
    }

    snomedct() {
        return axios.get('/snomedct-all')
    }

    searchIx(phrase, num_results) {
        return axios.get('/ix/search', {
            params: {
                'phrase': phrase,
                'num_results': num_results || 5
            }
        });
    }

    allModels = () => {
        return axios.get('/all_models');
    }

    allTags = () => {
        return [{tag: "AE", label: "Animals"},
            {tag: "AE.01", label: "Animals defined by eating habits"},
            {tag: "AE.02", label: "Animals defined by noises"},
            {tag: "AE.03", label: "Domestic animal"},
            {tag: "AE.04", label: "Animals hunted"},
            {tag: "AE.05", label: "Animal family unit"},
            {tag: "AE.06", label: "Animals collectively"},
            {tag: "AE.07", label: "Animal body"},
            {tag: "AE.07.a", label: "Markings/colourings"},
            {tag: "AE.07.b", label: "Body and limbs"},
            {tag: "AE.07.c", label: "Rump and tail"},
            {tag: "AE.07.d", label: "Covering/skin"},
            {tag: "AE.08", label: "Invertebrates"},
            {tag: "AE.08.a", label: "Protozoa"},
            {tag: "AE.08.b", label: "Division Vermes (worms)"},
            {tag: "AE.08.c", label: "Phylum Mollusca (moluscs)"},
            {tag: "AE.08.d", label: "Class Gastropoda (gastropods)"},
            {tag: "AE.08.e", label: "Class Pelecypoda/Conchifera (shellfish)"},
            {tag: "AE.08.f", label: "Class Cephalopoda (cephalopods)"},
            {tag: "AE.08.g", label: "Class Crustacea (crustaceans)"},
            {tag: "AE.08.h", label: "Class Arachnida (spiders, scorpions)"},
            {tag: "AE.08.i", label: "Class Insecta (insects)"},
            {tag: "AE.08.i.01", label: "Parts of insects"},
            {tag: "AE.08.i.02", label: "Eggs/young"},
            {tag: "AE.08.i.03", label: "Order Diptera (flies)"},
            {tag: "AE.08.i.04", label: "Order Siphonaptera (fleas)"},
            {tag: "AE.08.i.05", label: "Order Lepidoptera (butterflies, moths)"},
            {tag: "AE.08.i.06", label: "Rhopalocera (butterflies)"},
            {tag: "AE.08.i.07", label: "Heterocera (moths)"},
            {tag: "AE.08.i.08", label: "Order Coleoptera (beetles, weevils)"},
            {tag: "AE.08.i.09", label: "Order Hymenoptera (bees, wasps)"},
            {tag: "AE.09", label: "Vertebrates"},
            {tag: "AE.10", label: "Fish"},
            {tag: "AE.10.a", label: "Order Pleurotremata (sharks)"},
            {tag: "AE.10.b", label: "Subdivision Teleostei (eels)"},
            {tag: "AE.10.c", label: "Order Clupeiformes (herring and related fish)"},
            {tag: "AE.10.d", label: "Order Salmoniformes (salmon, trout)"},
            {tag: "AE.10.e", label: "Order Cyprinoidea (carp and related fish)"},
            {tag: "AE.10.f", label: "Order Gadiformes (cod)"},
            {tag: "AE.10.g", label: "Order Perciformes (perches)"},
            {tag: "AE.11", label: "Class Amphibia (amphibians)"},
            {tag: "AE.11.a", label: "Order Anura/Salienta (frogs, toads)"},
            {tag: "AE.12", label: "Class Reptilia (reptiles)"},
            {tag: "AE.12.a", label: "Extinct reptiles and dinosaurs"},
            {tag: "AE.12.b", label: "Order Chelonia (turtles, tortoises)"},
            {tag: "AE.12.c", label: "Order Crocodilia (crocodiles, alligators)"},
            {tag: "AE.12.d", label: "Order Squamata (lizards, snakes)"},
            {tag: "AE.12.d.01", label: "Suborder Lacertilia (lizards)"},
            {tag: "AE.12.d.02", label: "Suborder Ophidia (snakes)"},
            {tag: "AE.13", label: "Class Aves (birds)"},
            {tag: "AE.13.a", label: "Wild/domestic birds"},
            {tag: "AE.13.b", label: "Bird of prey"},
            {tag: "AE.13.c", label: "Sound/bird defined by"},
            {tag: "AE.13.d", label: "Egg"},
            {tag: "AE.13.e", label: "Young bird"},
            {tag: "AE.13.f", label: "Parts of/bird defined by"},
            {tag: "AE.13.g", label: "Feather"},
            {tag: "AE.13.h", label: "Order Galliformes (fowls)"},
            {tag: "AE.13.h.01", label: "Genus Gallus (domestic fowl)"},
            {tag: "AE.13.i", label: "Family Laridae (gulls, terns)"},
            {tag: "AE.13.j", label: "Order Ciconiiformes (storks and related birds)"},
            {tag: "AE.13.k", label: "Order Anseriformes (geese and related birds)"},
            {tag: "AE.13.k.01", label: "Subfamily Merginae (ducks)"},
            {tag: "AE.13.l", label: "Perching birds"},
            {tag: "AE.13.l.01", label: "Order Psittaciformes (parrots and related birds)"},
            {tag: "AE.13.l.02", label: "Order Columbiformes (doves, pigeons)"},
            {tag: "AE.13.m", label: "Order Strigiformes (owls)"},
            {tag: "AE.13.n", label: "Order Falconiformes (falcons and related birds)"},
            {tag: "AE.13.o", label: "Order Passeriformes (song-birds)"},
            {tag: "AE.13.o.01", label: "Family Corvidae (crows)"},
            {tag: "AE.14", label: "Class Mammalia (mammals)"},
            {tag: "AE.14.a", label: "Subclass Marsupialia (marsupials)"},
            {tag: "AE.14.b", label: "Order Cetacea (whales, dolphins)"},
            {tag: "AE.14.c", label: "Family Felidae (felines)"},
            {tag: "AE.14.c.01", label: "Felis domesticus (domestic cat)"},
            {tag: "AE.14.d", label: "Family Canidae (dogs)/member of"},
            {tag: "AE.14.d.02", label: "Dog"},
            {tag: "AE.14.e", label: "Family Ursidae (bears)"},
            {tag: "AE.14.f", label: "Family Mustelidae (weasel, marten, otter, badger)"},
            {tag: "AE.14.g", label: "Order Pinnipedia (seal, sea lion, walrus)"},
            {tag: "AE.14.h", label: "Order Rodentia (rodents)"},
            {tag: "AE.14.i", label: "Order Lagomorpha (rabbits, hares)"},
            {tag: "AE.14.j", label: "Family Equidae (general equines)"},
            {tag: "AE.14.j.01", label: "Equus caballus (horse)"},
            {tag: "AE.14.j.02", label: "Horse defined by purpose"},
            {tag: "AE.14.j.03", label: "Body/parts of horse"},
            {tag: "AE.14.j.04", label: "Habits and actions of horse"},
            {tag: "AE.14.j.05", label: "Horse defined by speed/gait"},
            {tag: "AE.14.k", label: "Order Proboscidea (elephants)"},
            {tag: "AE.14.l", label: "Family Suidae (pigs)"},
            {tag: "AE.14.m", label: "Group Ruminantia (sheep, goats, cows)"},
            {tag: "AE.14.m.01", label: "Genus Ovis (sheep)"},
            {tag: "AE.14.m.02", label: "Subfamily Caprinae (goats)"},
            {tag: "AE.14.m.03", label: "Subfamily Bovinae (bovines)"},
            {tag: "AE.14.m.04", label: "Bos taurus (ox)"},
            {tag: "AE.14.m.05", label: "Bull"},
            {tag: "AE.14.m.06", label: "Cow"},
            {tag: "AE.14.m.07", label: "Antelope"},
            {tag: "AE.14.m.08", label: "Family Cervidae (deer)"},
            {tag: "AE.14.n", label: "Order Chiroptera (bats)"},
            {tag: "AE.14.o", label: "Order Primates"},
            {tag: "AE.14.o.01", label: "Suborder Anthropoidea (higher primates)"},
            {tag: "AE.15", label: "Zoology"},
            {tag: "AE.15.a", label: "Study of specific types of animal"},
            {tag: "AE.15.b", label: "Taxidermy"},
            {tag: "AF", label: "Plants"},
            {tag: "AF.01", label: "Plants collectively"},
            {tag: "AF.02", label: "Wild/cultivated plants"},
            {tag: "AF.02.a", label: "Food plant/vegetable"},
            {tag: "AF.03", label: "Valued plants and weeds"},
            {tag: "AF.03.a", label: "Edible product/fruit"},
            {tag: "AF.04", label: "Plants defined by habitat/distribution"},
            {tag: "AF.05", label: "Plants defined by age/cycles"},
            {tag: "AF.06", label: "Plants defined by growth/development"},
            {tag: "AF.06.a", label: "Plants defined by good growth"},
            {tag: "AF.06.b", label: "Plants defined by poor growth"},
            {tag: "AF.06.c", label: "Plants defined by habit"},
            {tag: "AF.07", label: "Tree/woody plant"},
            {tag: "AF.07.a", label: "Wood/assemblage of trees/shrubs"},
            {tag: "AF.08", label: "Defined by nutrition/respiration, etc."},
            {tag: "AF.09", label: "Appearance of plant"},
            {tag: "AF.10", label: "Part of plant"},
            {tag: "AF.10.a", label: "Stem/stalk"},
            {tag: "AF.10.b", label: "Shoot/sprout/branch"},
            {tag: "AF.10.c", label: "Bud"},
            {tag: "AF.10.d", label: "Root"},
            {tag: "AF.10.e", label: "Leaf"},
            {tag: "AF.10.f", label: "Plant substances"},
            {tag: "AF.10.g", label: "Flower/part containing reproductive organs"},
            {tag: "AF.10.h", label: "Reproductive product - fruit, nut"},
            {tag: "AF.10.i", label: "Seed"},
            {tag: "AF.10.j", label: "Spore"},
            {tag: "AF.10.k", label: "Cell/aggregate tissue"},
            {tag: "AF.10.l", label: "Wood, other part of tree/woody plant"},
            {tag: "AF.11", label: "Disease of/injury to plants"},
            {tag: "AF.12", label: "Particular plants/herbs/shrubs"},
            {tag: "AF.12.a", label: "A grass/grasses"},
            {tag: "AF.13", label: "Particular tree/shrub"},
            {tag: "AF.13.a", label: "Oak and allies"},
            {tag: "AF.13.b", label: "Conifers"},
            {tag: "AF.13.c", label: "Non-British trees/shrubs"},
            {tag: "AF.13.d", label: "Particular shrubs"},
            {tag: "AF.14", label: "Cactus and allies"},
            {tag: "AF.15", label: "Ferns"},
            {tag: "AF.16", label: "Moss"},
            {tag: "AF.17", label: "Fungi"},
            {tag: "AF.18", label: "Lichen"},
            {tag: "AF.19", label: "Algae, seaweed"},
            {tag: "AF.20", label: "Particular food plant/product"},
            {tag: "AF.20.a", label: "Particular types of fruit"},
            {tag: "AF.20.b", label: "Particular fruit-tree/-plant"},
            {tag: "AF.20.c", label: "Edible nuts/nut-trees"},
            {tag: "AF.20.d", label: "Edible pods/seeds/leaves/flowers"},
            {tag: "AF.20.e", label: "Particular vegetables"},
            {tag: "AF.20.f", label: "Pulses/plants producing pulses"},
            {tag: "AF.20.g", label: "Cereal/corn/grain"},
            {tag: "AF.20.h", label: "Yielding condiments/used in food preparation"},
            {tag: "AF.20.i", label: "Particular fodder plants"},
            {tag: "AF.21", label: "Particular medicinal/food plants/parts"},
            {tag: "AF.21.a", label: "Medicinal trees/shrubs"},
            {tag: "AF.21.b", label: "Particular medicinal/food plants"},
            {tag: "AF.22", label: "Yielding drug/narcotic"},
            {tag: "AF.23", label: "Particular timber trees/shrubs"},
            {tag: "AF.24", label: "Yielding fibre/thatching/basket material"},
            {tag: "AF.25", label: "Particular tree/plant yielding useful gum/resin"},
            {tag: "AF.26", label: "Plant/nut/bean yielding oil"},
            {tag: "AF.27", label: "Plants used in dyeing"},
            {tag: "AF.28", label: "Fragrant plants/plants used in perfumery"},
            {tag: "AF.29", label: "Particular cultivated/ornamental plants"},
            {tag: "AF.29.a", label: "Cultivated/ornamental trees/shrubs"},
            {tag: "AF.30", label: "Plants perceived as weeds/harmful plants"},
            {tag: "AF.30.a", label: "Weed"},
            {tag: "AF.30.b", label: "Poisonous/harmful plants"},
            {tag: "AF.30", label: "Botany"},
            {tag: "AG", label: "Food and drink"},
            {tag: "AG.01", label: "Food"},
            {tag: "AG.01.a", label: "Qualities of food"},
            {tag: "AG.01.b", label: "Consistency of food"},
            {tag: "AG.01.c", label: "Diet"},
            {tag: "AG.01.d", label: "Animals for food"},
            {tag: "AG.01.d.01", label: "Preserved meat"},
            {tag: "AG.01.d.02", label: "Part/joint of animal"},
            {tag: "AG.01.d.03", label: "Beef"},
            {tag: "AG.01.d.04", label: "Mutton"},
            {tag: "AG.01.d.05", label: "Pork"},
            {tag: "AG.01.d.06", label: "Fowls"},
            {tag: "AG.01.d.07", label: "Seafood"},
            {tag: "AG.01.e", label: "Dairy produce"},
            {tag: "AG.01.e.01", label: "Butter"},
            {tag: "AG.01.e.02", label: "Cheese"},
            {tag: "AG.01.f", label: "Fat/oil"},
            {tag: "AG.01.g", label: "Eggs"},
            {tag: "AG.01.h", label: "Fruit and vegetables"},
            {tag: "AG.01.h.01", label: "Fruit/a fruit"},
            {tag: "AG.01.h.01.a", label: "Citrus fruit"},
            {tag: "AG.01.h.01.b", label: "Berry"},
            {tag: "AG.01.h.01.c", label: "Apple"},
            {tag: "AG.01.h.01.d", label: "Pear"},
            {tag: "AG.01.h.01.e", label: "Fruit containing stone"},
            {tag: "AG.01.h.01.f", label: "Nut"},
            {tag: "AG.01.h.02", label: "Vegetables"},
            {tag: "AG.01.h.02.a", label: "Root vegetable"},
            {tag: "AG.01.h.02.b", label: "Stalk vegetables"},
            {tag: "AG.01.h.02.c", label: "Leaf vegetables"},
            {tag: "AG.01.h.02.d", label: "Cabbage/kale"},
            {tag: "AG.01.h.02.e", label: "Onion/leek/garlic"},
            {tag: "AG.01.h.02.f", label: "Fruits as vegetables"},
            {tag: "AG.01.h.02.g", label: "Pulse"},
            {tag: "AG.01.h.02.h", label: "Fungi"},
            {tag: "AG.01.h.02.i", label: "Herb"},
            {tag: "AG.01.i", label: "Corn/cereals/grain"},
            {tag: "AG.01.j", label: "Meal"},
            {tag: "AG.01.k", label: "Flour"},
            {tag: "AG.01.l", label: "Additive"},
            {tag: "AG.01.l.01", label: "Salt"},
            {tag: "AG.01.l.02", label: "Sweetener (syrup/honey/chocolate)"},
            {tag: "AG.01.l.03", label: "Spice"},
            {tag: "AG.01.l.04", label: "Sauce/dressing"},
            {tag: "AG.01.m", label: "Substances for food preparation"},
            {tag: "AG.01.n", label: "Dishes and prepared food"},
            {tag: "AG.01.n.01", label: "Food by way of preparation"},
            {tag: "AG.01.n.02", label: "Soup/pottage"},
            {tag: "AG.01.n.03", label: "Puddings"},
            {tag: "AG.01.n.04", label: "Jelly"},
            {tag: "AG.01.n.05", label: "Sausage"},
            {tag: "AG.01.n.06", label: "Meat dishes"},
            {tag: "AG.01.n.07", label: "Fish dishes"},
            {tag: "AG.01.n.08", label: "Prepared fruit and dishes"},
            {tag: "AG.01.n.09", label: "Prepared vegetables and dishes"},
            {tag: "AG.01.n.10", label: "Grain dishes"},
            {tag: "AG.01.n.11", label: "Bread"},
            {tag: "AG.01.n.12", label: "Pancake/tortilla/oatcake"},
            {tag: "AG.01.n.13", label: "Cake"},
            {tag: "AG.01.n.14", label: "Biscuit"},
            {tag: "AG.01.n.15", label: "Pastry"},
            {tag: "AG.01.n.16", label: "Egg dishes"},
            {tag: "AG.01.n.17", label: "Confections/sweetmeats"},
            {tag: "AG.01.n.17.a", label: "Sweets"},
            {tag: "AG.01.n.17.b", label: "Ices"},
            {tag: "AG.01.n.18", label: "Preserve"},
            {tag: "AG.01.o", label: "Animal food"},
            {tag: "AG.01.p", label: "Amounts of food"},
            {tag: "AG.01.q", label: "Supply of food/provisions"},
            {tag: "AG.01.r", label: "Meal"},
            {tag: "AG.01.r.01", label: "Meal-time"},
            {tag: "AG.01.r.02", label: "Course"},
            {tag: "AG.01.r.03", label: "Feast"},
            {tag: "AG.01.r.04", label: "Picnic/packed meal"},
            {tag: "AG.01.s", label: "Providing/receiving food"},
            {tag: "AG.01.s.01", label: "Feeding animals"},
            {tag: "AG.01.t", label: "Food manufacture and preparation"},
            {tag: "AG.01.t.01", label: "Preparation of grain"},
            {tag: "AG.01.t.02", label: "Preparation of dairy produce"},
            {tag: "AG.01.t.03", label: "Sugar manufacture"},
            {tag: "AG.01.t.04", label: "Salt manufacture"},
            {tag: "AG.01.t.05", label: "Preparation for table/cooking"},
            {tag: "AG.01.t.06", label: "Preserving/pickling"},
            {tag: "AG.01.t.07", label: "Cooking"},
            {tag: "AG.01.t.08", label: "Equipment for food preparation"},
            {tag: "AG.01.u", label: "Container for food, place for storing food"},
            {tag: "AG.01.v", label: "Serving food"},
            {tag: "AG.01.w", label: "Setting table"},
            {tag: "AG.01.x", label: "Consumption of food/drink"},
            {tag: "AG.01.x.01", label: "Eating"},
            {tag: "AG.01.x.01.a", label: "Eating place"},
            {tag: "AG.01.x.02", label: "Appetite"},
            {tag: "AG.01.x.02.a", label: "Hunger"},
            {tag: "AG.01.x.02.b", label: "Excessive consumption of food/drink"},
            {tag: "AG.01.x.02.c", label: "Fasting"},
            {tag: "AG.01.y", label: "Drink"},
            {tag: "AG.01.y.01", label: "Intoxicating liquor"},
            {tag: "AG.01.y.01.a", label: "Wine"},
            {tag: "AG.01.y.01.b", label: "Ale/beer"},
            {tag: "AG.01.y.01.c", label: "Cider"},
            {tag: "AG.01.y.01.d", label: "Whisky"},
            {tag: "AG.01.y.01.e", label: "Brandy"},
            {tag: "AG.01.y.01.f", label: "Gin"},
            {tag: "AG.01.y.01.g", label: "Cocktail"},
            {tag: "AG.01.z", label: "Water"},
            {tag: "AG.01.aa", label: "Aerated/carbonated drink"},
            {tag: "AG.01.ab", label: "Fruit juice/squash"},
            {tag: "AG.01.ac", label: "Tea"},
            {tag: "AG.01.ad", label: "Coffee"},
            {tag: "AG.01.ae", label: "Manufacture of alcoholic drink"},
            {tag: "AG.01.ae.01", label: "Wine-making"},
            {tag: "AG.01.ae.02", label: "Malting"},
            {tag: "AG.01.ae.03", label: "Brewing"},
            {tag: "AG.01.ae.04", label: "Distilling"},
            {tag: "AG.01.af", label: "Tea manufacture"},
            {tag: "AG.01.ag", label: "Coffee manufacture"},
            {tag: "AG.01.ah", label: "Preparation of drinks"},
            {tag: "AG.01.ai", label: "Providing/serving drink"},
            {tag: "AG.01.aj", label: "Containers for drink"},
            {tag: "AG.01.aj.01", label: "Drinking vessel"},
            {tag: "AG.01.ak", label: "Drinking"},
            {tag: "AG.01.ak.01", label: "Drinking place"},
            {tag: "AG.01.ak.02", label: "Thirst"},
            {tag: "AG.01.ak.02.a", label: "Excess in drinking"},
            {tag: "AG.01.ak.02.b", label: "Moderation in drinking"},
            {tag: "AG.01.ak.02.c", label: "Abstention from drinking"},
            {tag: "AG.02", label: "Production of food, farming"},
            {tag: "AG.02.a", label: "Farmer"},
            {tag: "AG.02.b", label: "Farm"},
            {tag: "AG.02.b.01", label: "Farmstead"},
            {tag: "AG.02.b.02", label: "Farmland"},
            {tag: "AG.02.c", label: "Cultivation/tillage"},
            {tag: "AG.02.c.01", label: "Fertilizing/manuring"},
            {tag: "AG.02.c.02", label: "Ploughing"},
            {tag: "AG.02.c.03", label: "Sowing"},
            {tag: "AG.02.c.04", label: "Planting"},
            {tag: "AG.02.c.05", label: "Cultivation of plants/crops"},
            {tag: "AG.02.c.05.a", label: "Crop/crops"},
            {tag: "AG.02.c.05.b", label: "Harvesting"},
            {tag: "AG.02.c.05.c", label: "Storage/preservation of crops"},
            {tag: "AG.02.d", label: "Tools and implements"},
            {tag: "AG.02.e", label: "Gardening"},
            {tag: "AG.02.e.01", label: "Garden"},
            {tag: "AG.02.e.02", label: "Propagation of plants"},
            {tag: "AG.02.e.03", label: "Equipment and buildings"},
            {tag: "AG.02.f", label: "Forestry/arboriculture"},
            {tag: "AG.02.g", label: "Animal husbandry"},
            {tag: "AG.02.g.01", label: "Herding/pasturing/confining"},
            {tag: "AG.02.g.02", label: "Animal enclosure/house general"},
            {tag: "AG.02.g.03", label: "Keeping of cattle"},
            {tag: "AG.02.g.04", label: "Dairy farming"},
            {tag: "AG.02.g.05", label: "Sheep-farming"},
            {tag: "AG.02.g.06", label: "Keeping of pigs"},
            {tag: "AG.02.g.07", label: "Keeping/management of horses"},
            {tag: "AG.02.g.07.a", label: "Shoeing of horses"},
            {tag: "AG.02.g.07.b", label: "Horse-gear"},
            {tag: "AG.02.g.08", label: "Keeping birds"},
            {tag: "AG.02.g.08.a", label: "Poultry-keeping"},
            {tag: "AG.02.g.09", label: "Fish-keeping/-farming/-breeding"},
            {tag: "AG.02.g.10", label: "Bee-keeping"},
            {tag: "AG.02.g.11", label: "Keeping dogs/cats"},
            {tag: "AG.02.g.12", label: "Zoo"},
            {tag: "AG.03", label: "Acquisition of animals for food, hunting"},
            {tag: "AG.03.a", label: "Hunting with hounds"},
            {tag: "AG.03.b", label: "Hunting specific animals"},
            {tag: "AG.03.c", label: "Hunter"},
            {tag: "AG.03.d", label: "Thing hunted/game"},
            {tag: "AG.03.e", label: "Equipment for hunting"},
            {tag: "AG.03.f", label: "Shooting"},
            {tag: "AG.03.g", label: "Fowling"},
            {tag: "AG.03.h", label: "Hawking"},
            {tag: "AG.03.i", label: "Fishing"},
            {tag: "AG.03.i.01", label: "Fisher"},
            {tag: "AG.03.i.02", label: "Fishing-tackle"},
            {tag: "AG.03.j", label: "Whaling"},
            {tag: "X", label: "Object"},
            {tag: "D", label: "Disease"}];
    }

}

export default new DocumentTags();